import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-white" data-id="element-92" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-letter px-4 py-7 text-center sm:px-6 sm:py-8" data-id="element-93" data-mp="9ttj2hqfwb1t">
        <p className="text-[0.68rem] font-extrabold uppercase tracking-[0.14em] text-brand" data-id="element-94" data-mp="et65x2hb9i4e">
          Tu inversión está protegida
        </p>

        <Reveal className="mt-2.5 flex flex-col items-center rounded-xl border-2 border-brand bg-mist p-4 sm:p-5" data-id="element-95" data-mp="jrr6x44e05tw">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand" data-id="element-96" data-mp="nsb4g8svhbgk">
            <ShieldCheckIcon size={24} className="text-white" aria-hidden="true" data-id="element-97" data-mp="slmcuedc20al" />
          </span>
          <h2 id="garantia" className="mt-2 font-display text-xl uppercase leading-tight tracking-tight text-brand-dark sm:text-2xl" data-id="element-98" data-mp="xj5pxayao70y">
            Garantía total de 7 días
          </h2>
          <p className="mt-1.5 max-w-xl text-[0.82rem] font-medium leading-snug text-ink-muted sm:text-sm" data-id="element-99" data-mp="17fquxwabdi4s">
            Tenés 7 días para explorar los 6 tomos y los 5 bonos. Si considerás
            que el sistema no es adecuado para vos, podés solicitar un reembolso
            dentro del período establecido según los términos de devolución.
          </p>
        </Reveal>
      </div>
    </section>;
}